export const mutations = {
    incrementCounter(state, value1) {
        state.counter = value1;
    },
    resetCounter(state) {
        state.counter = 0;
    },
    updateClientId(state, clientId) {
        state.clientId = clientId;
    },
    updateCompanyId(state, companyId) {
        state.companyId = companyId;
    },
    updateEnvironmentName(state, timezone) {
        state.environmentName = timezone;
    },
    updateDirtyPageValidation(state, pageValidation) {
        state.dirtyPageValidation = pageValidation;
    },
    resetDirtyPageValidation(state) {
        state.dirtyPageValidation = {
            dirty: false,
            message: ''
        };
    },
    updateIsSelectable(state, isSelectable) {
        state.isSelectable = isSelectable;
    },
    updateSelectedAudienceID(state, selectedAudienceID) {
        state.selectedAudienceID = selectedAudienceID;
    },
};
//# sourceMappingURL=mutations.js.map